const pass_regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#&()\-[{}\]_%\\:;|"'`,?/*~$^+=<>.]).{8,}$/;

export function isPasswordValid(pass) {
    return pass_regex.test(pass);
}